export default __webpack_public_path__ + "static/oksuruk_cover_2023-1fe69947b16e30fa81e45fabc6916845.webp";